import Axios from './APIService';
import { AxiosPromise, AxiosRequestConfig } from 'axios';

import Product from '@/types/Product';

const apiBase = '/products';

const admin = '/admin';

const ProductAPI = {

    get(): AxiosPromise<Product[]> {
        return Axios.get(apiBase);
    },

    getAll(): AxiosPromise<Product[]> {
        return Axios.get(`${admin}${apiBase}`);
    },

    getProduct(productId: string): AxiosPromise<Product[]> {
        return Axios.get(`${admin}${apiBase}/${productId}`);
    },

    post(product: Product): AxiosPromise<Product> {
        return Axios.post(`${admin}${apiBase}`, product);
    },

    postImage(productId: string, formData: FormData, config: AxiosRequestConfig): AxiosPromise<Product> {
        return Axios.post(`${admin}${apiBase}/${productId}/images`, formData, config);
    },

    deleteImage(productId: string, imageId: string): AxiosPromise<Product> {
        return Axios.delete(`${admin}${apiBase}/${productId}/images/${imageId}`);
    },

    postIconImage(productId: string, formData: FormData, config: AxiosRequestConfig): AxiosPromise<Product> {
        return Axios.post(`${admin}${apiBase}/${productId}/iconImage`, formData, config);
    },

    deleteIconImage(productId: string): AxiosPromise<Product> {
        return Axios.delete(`${admin}${apiBase}/${productId}/iconImage`);
    }

};

export default ProductAPI;
